import { Link } from 'react-router-dom';
import '../styles/HeroBoxStyles.css';
import React, { useState, useEffect } from 'react';

const isReactSnap = typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';

const HeroBanner = () => {
  const [stage, setStage] = useState(isReactSnap ? 4 : 0);

  useEffect(() => {
    if (isReactSnap) return;
    const timers = [
      setTimeout(() => setStage(1), 300),   // container
      setTimeout(() => setStage(2), 600),   // headline
      setTimeout(() => setStage(3), 1000),  // subtitle
      setTimeout(() => setStage(4), 1400),  // CTA buttons
    ];
    return () => timers.forEach(clearTimeout);
  }, []);

  const stagger = (step) =>
    stage >= step
      ? 'hero-stagger hero-stagger--visible'
      : 'hero-stagger';

  return (
    <div className="z-10 p-4 md:p-12 text-center flex flex-col justify-center items-center" style={{ position: 'relative' }}>
      <div className={`bg-black/30 rounded-xl px-6 py-4 inline-block max-w-2xl ${stagger(1)}`}>
        <h1 className={`ctahero-text-item ${stagger(2)}`} style={{ marginBottom: '0.5rem' }}>
          Industrial-Strength Vegetation Management.
        </h1>
        <p className={`text-white text-lg md:text-xl lg:text-2xl mb-6 max-w-prose font-semibold ${stagger(3)}`} style={{ textShadow: '0 2px 4px rgba(0,0,0,0.7)' }}>
          Boultbee delivers certified herbicide application programs to railroads, refineries, utilities, and municipalities across British Columbia. Technology-driven. IPM compliant. Results guaranteed.
        </p>
        <div className={`flex flex-col sm:flex-row gap-4 items-center ${stagger(4)}`}>
          <Link to="/contact" className="ctahero-button">
            Request a Free Site Assessment
          </Link>
          <a href="tel:1-250-492-0296" className="text-white text-lg font-bold px-4 py-3 rounded-lg min-h-[44px] inline-flex items-center" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.7)', backgroundColor: 'rgba(0,0,0,0.35)' }}>
            or call (250) 492-0296
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;
